export var cibLinuxFoundation = ["32 32", "<path d='M6.401 12.802v12.797h12.797v6.401h-19.198v-19.198zM32 0v32h-9.599v-6.401h3.198v-19.198h-19.198v3.198h-6.401v-9.599z'/>"];
